module.exports = __webpack_public_path__ + "static/img/Site Administrator.a07cd0ce.png";